import React from 'react';

const GuidelinesOffBtn = (props) => (
    <div 
    	className={`guidelines-off-btn guidelines-btn ${props.selected && 'on'}`} 
    	onClick={props.onClick}
    ></div>
);

export default GuidelinesOffBtn;


// WEBPACK FOOTER //
// ./src/components/sections/shared/GuidelinesOffBtn.js